import { useCurrency } from '../context/CurrencyContext';
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from './ui/select';

export function CurrencySelector({ className = '' }) {
  const { currency, setCurrency, getAvailableCurrencies } = useCurrency();
  const currencies = getAvailableCurrencies();

  return (
    <Select value={currency} onValueChange={setCurrency}>
      <SelectTrigger className={`w-24 ${className}`} data-testid="currency-selector">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {currencies.map((curr) => (
          <SelectItem key={curr.code} value={curr.code}>
            <span className="flex items-center gap-2">
              <span className="font-medium">{curr.symbol}</span>
              <span>{curr.code}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default CurrencySelector;
